import React, { ChangeEventHandler, useMemo } from 'react'
import { ReceptorRecord } from '@trustero/trustero-api-web/lib/agent/receptor_pb'
import { StyledLabel } from '../../../Reusable/Inputs/TextInput/styles'
import {
  ReceptorFormInput,
  ReceptorFormErrorMsg,
} from './ActivateReceptorForm.styles'

export function ReceptorCredentialsField({
  label,
  name,
  value,
  placeholder,
  onChange,
  errorMsg,
  type,
}: {
  receptor: ReceptorRecord.AsObject
  type: string
  label: string
  name: string
  value: string
  placeholder: string
  onChange: ChangeEventHandler<HTMLInputElement>
  errorMsg: string
}): JSX.Element {
  const failedCredentials = useMemo(
    () => errorMsg === 'Invalid credentials',
    [errorMsg],
  )
  const status = useMemo(
    () => (failedCredentials ? 'error' : 'default'),
    [failedCredentials],
  )
  if (name === 'oauth') {
    return <></>
  }
  return (
    <StyledLabel>
      <p>{label}</p>
      <ReceptorFormInput
        required
        disabled={false}
        name={name}
        value={value}
        placeholder={placeholder}
        onChange={onChange}
        status={status}
        type={type}
      />
      <ReceptorFormErrorMsg status={status}>
        {failedCredentials && errorMsg}
      </ReceptorFormErrorMsg>
    </StyledLabel>
  )
}
